<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="false",  ref="ruleForm" label-width="120px")
            el-card(shadow="never")
                div
                    el-form-item(label="俱乐部名:" prop="name")
                        font {{ruleForm.name}}
                    //- el-form-item(label="add加盟方:" prop="name")
                    //-     font {{ruleForm.name}}
                    el-form-item(label="会长:" prop="chairman")
                        font {{ruleForm.chairman}}
                    el-form-item(label="会长账号:" prop="chairmanId")
                        font {{ruleForm.chairmanId}}
                    el-form-item(label="全员女子:" prop="allWomen")
                        font {{ruleForm.allWomen}}
                    el-form-item(label="等级:" prop="level")
                        font {{ruleForm.level}}
                    el-form-item(label="队标:" prop="teamLogo")
                        <img :src="listImageUrl" :onerror="defaultImg" style="width:100px;height:100px"/>
                    el-form-item(label="俱乐部照片:" prop="teamLogo")
                        <img v-for='(item,index) in ruleForm.cbClubPhotoList' :src="item.imgUrl" :onerror="defaultImg" style="width:100px;height:100px;margin-right:10px"/>
                    el-form-item(label="简介:" prop="intro")
                       font(v-html="ruleForm.intro" style="margin-top:-15px")
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返 回

</template>
<script>
export default {
  data () {
    return {
      type: '',
      title: '查看详情',
      defaultImg: '../../../mb/img/img.jpg',
      ruleForm: {
        id: null,
        name: '',
        chairman: '',
        chairmanId: '',
        level: '',
        allWomen: '',
        teamLogo: '',
        intro: '',
        cbClubPhotoList: []
      },
      visible: false,
      listImageUrl: ''
    }
  },
  methods: {
    init (id, type) {
      this.title = '查看基本信息'
      this.ruleForm.id = id || null
      this.type = type
      this.listImageUrl = ''
      if (type == 'release') {
        this.title = '审核发布'
      }
      this.$nextTick(() => {
        this.visible = true
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].resetFields()
        }
      })
      //回选
      if (this.ruleForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/cbClub/getId/` + this.ruleForm.id),
          method: 'get'
        }).then((data) => {
          if (data && data.code === 0) {
            console.log(data.bean)
            this.ruleForm.name = data.bean.name
            this.ruleForm.chairman = data.bean.chairman
            this.ruleForm.chairmanId = data.bean.chairmanAccount
            this.ruleForm.allWomen = data.bean.allWomen == 1 ? '是' : '否'
            this.ruleForm.level = this.dengji(data.bean.level)
            this.ruleForm.intro = data.bean.intro.replace(/<\/?.+?>/g, '')
            this.ruleForm.cbClubPhotoList = data.bean.cbClubPhotoList
            this.listImageUrl = data.bean.logoImgUrl
            // if (data.bean.teamLogo != '' && data.bean.teamLogo != null) {
            //   this.listImageUrl = 'data:image/png;base64,' + data.bean.teamLogo
            // }
          }
          this.$forceUpdate()
        })
      }
    },
    dengji (val) {
      let obj = {
        1: '甲A',
        2: '甲B',
        3: '乙A',
        4: '乙B',
        5: '丙A',
        6: '丙B',
        7: '丁A',
        8: '丁B',
        9: '资格'
      }
      if (obj[val]) return obj[val]
      return '其他'
    }
  }
}
</script>
<style scoped>
/* .labelStyle >>>.el-form-item__label{
        color: rgb(43, 40, 40);
        font-weight:bold;
    } */
</style>
